import { render, staticRenderFns } from "./QuestionTagsSelector.vue?vue&type=template&id=05b347a3&"
import script from "./QuestionTagsSelector.vue?vue&type=script&lang=js&"
export * from "./QuestionTagsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports